export default __webpack_public_path__ + "static/media/arrow-up.e0895fae.svg";